import { Col } from '../grid';
export default Col;



// WEBPACK FOOTER //
// ./components/col/index.tsx